import { Link, useNavigate, useParams } from "react-router";
import "./ShowEmployee.css";
import API from "../../api/axiosConfig";
import { useEffect, useState } from "react";
import TestPreloader from "../TestPreLoader/TestPreLoader";
import { Button } from "react-bootstrap";

function ShowEmployee() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState({});
  const [message, setMessage] = useState([]);
  const [showMore, setShowMore] = useState(false);
  const getEmployee = async () => {
    try {
      const res = await API.get(`/employees/${id}`);
      const data = await res;
      if (data.status === 200) {
        setRows(data?.data);
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
      setError(error.response.data.errors);
      setMessage(error.response.data.message);
    }
  };
  useEffect(() => {
    getEmployee();
  }, []);
  const link = `/editemployee/${rows.id}`;
  return loading ? (
    <TestPreloader />
  ) : (
    <>
      <div className="showEmployee">
        <div className="empPhotoEditContainer">
          <div className="empPhotoContainer">
            <img
              width="70px"
              alt="Employee"
              className="empImg"
              src={rows && rows.photo ? rows.photo : "https://img.freepik.com/free-vector/user-blue-gradient_78370-4692.jpg?semt=ais_hybrid"}
            />
            <div className="empEmailEditContainer">
              <p className="empName"> {rows && rows.name ? rows.name : ""}</p>
              <span className="empEmail">
                {rows && rows.email ? rows.email : ""}
              </span>
            </div>
          </div>
          {/* <Link to={link} className='EmpEditBtn'>تعديل</Link> */}
        </div>

        <div className="empInfoContainer">
          <div className="empInfoContainerRow">
            <div className="EmpInfoField">
              <span className="infoFeld">الإسم</span>

              <h5 className="infoContent">
                {" "}
                {rows && rows.name ? rows.name : ""}
              </h5>
            </div>
            <div className="EmpInfoField">
              <span className="infoFeld">المسمي الوظيفي</span>

              <h5 className="infoContent">
                {rows && rows.jobtitle ? rows.jobtitle.title : ""}
              </h5>
            </div>
          </div>
          <div className="empInfoContainerRow">
            <div className="EmpInfoField">
              <span className="infoFeld">العنوان</span>

              <h5 className="infoContent">
                {" "}
                {rows && rows.address ? rows.address : ""}
              </h5>
            </div>
            <div className="EmpInfoField">
              <span className="infoFeld">البريد الإلكتروني</span>

              <h5 className="infoContent">
                {rows && rows.email ? rows.email : ""}
              </h5>
            </div>
          </div>
          <div className="empInfoContainerRow">
            <div className="EmpInfoField">
              <span className="infoFeld">تاريخ الميلاد</span>

              <h5 className="infoContent">
                {" "}
                {rows && rows.dateofbirth
                  ? rows.dateofbirth.split("T")[0]
                  : ""}{" "}
              </h5>
            </div>
            <div className="EmpInfoField">
              <span className="infoFeld">العمر</span>

              <h5 className="infoContent">35</h5>
            </div>
          </div>
          <div className="empInfoContainerRow">
            <div className="EmpInfoField">
              <span className="infoFeld">رقم الجوال</span>

              <h5 className="infoContent">
                {rows && rows.phone ? rows.phone : ""}
              </h5>
            </div>
            <div className="EmpInfoField">
              <span className="infoFeld">تاريخ بدء الخدمة</span>

              <h5 className="infoContent">{rows ? rows.dateofhire : ""}</h5>
            </div>
          </div>
          {showMore && (
            <>
              <div className="empInfoContainerRow">
                <div className="EmpInfoField">
                  <span className="infoFeld">الرقم القومي</span>
                  <h5 className="infoContent">{rows?.nationalid || ""}</h5>
                </div>

                <div className="EmpInfoField">
                  <span className="infoFeld">تاريخ انتهاء الهوية</span>
                  <h5 className="infoContent">
                    {rows?.nationalid_expire?.split("T")[0] || ""}
                  </h5>
                </div>
              </div>

              <div className="empInfoContainerRow">
                <div className="EmpInfoField">
                  <span className="infoFeld">الجنسية</span>
                  <h5 className="infoContent">{rows?.nationality || ""}</h5>
                </div>

                <div className="EmpInfoField">
                  <span className="infoFeld">IBAN</span>
                  <h5 className="infoContent">{rows?.ibannumber || ""}</h5>
                </div>
              </div>

              <div className="empInfoContainerRow">
                <div className="EmpInfoField">
                  <span className="infoFeld">المؤهل العلمي</span>
                  <h5 className="infoContent">{rows?.qualification || ""}</h5>
                </div>

                <div className="EmpInfoField">
                  <span className="infoFeld">تاريخ انتهاء العقد</span>
                  <h5 className="infoContent">
                    {rows?.contractexpiration || ""}
                  </h5>
                </div>
              </div>
            </>
          )}
        </div>
        <button className="more-btn" onClick={() => setShowMore(!showMore)}>
          {showMore ? "عرض اقل" : "عرض المزيد"}
        </button>
      </div>
    </>
  );
}

export default ShowEmployee;
